export const FETCH_VEHICLES_CATEGORIES_DATA = "FETCH_VEHICLES_CATEGORIES_DATA";
export const FETCH_VEHICLES_CATEGORIES_SUCCESS = "FETCH_VEHICLES_CATEGORIES_SUCCESS";
export const FETCH_VEHICLES_CATEGORIES_FAILURE = "FETCH_VEHICLES_CATEGORIES_FAILURE";

export const FETCH_VEHICLES_CATEGORIES_EDIT_DATA = "FETCH_VEHICLES_CATEGORIES_EDIT_DATA";
export const FETCH_VEHICLES_CATEGORIES_EDIT_SUCCESS = "FETCH_VEHICLES_CATEGORIES_EDIT_SUCCESS";
export const FETCH_VEHICLES_CATEGORIES_EDIT_FAILURE = "FETCH_VEHICLES_CATEGORIES_EDIT_FAILURE";